import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Document from "./Accountings/Document";
import GridConfig from "./GridConfig";
import { NavLink } from 'react-router-dom';

export default class TransactionReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: 1,
            data: null,
            loading: true,
            configName: 'tafsiltransaction_report',
            systemModuleId: 8,
            moduleAccessStatus: 1,
            groupByMoein: false,
        }
    }
    componentWillReceiveProps(p) {
        this.refreshData();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.refreshData();
            });
    }
    refreshData() {
        var tafsilType = this.getCurrentFormId2();
        var tafsilCode = this.getCurrentFormId();
        this.httpPost("api/v1/report/tafsiltransaction", {
            tafsilType: tafsilType,
            tafsilCode: tafsilCode,
            groupByMoein: this.state.groupByMoein
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "date", caption: "تاریخ", show: !this.state.groupByMoein },
                { field: "documentNumber", caption: "سند", show: !this.state.groupByMoein },
                { field: "moeinTitle", caption: "معین", show: true },
                { field: "description", caption: "شرح", show: !this.state.groupByMoein },
                { field: "bed", caption: (this.state.groupByMoein ? "گردش بدهکار" : "بدهکار"), show: true },
                { field: "bes", caption: (this.state.groupByMoein ? "گردش بستانکار" : "بستانکار"), show: true },
                { field: "remain", caption: "مانده", show: true },
                { field: "tashkis", caption: "تشخیص", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'date' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'moeinTitle' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <NavLink to={"/report/transactions/" + props.data.tafsilId + "/" + props.data.moeinId + "/"} className="text-primary txt-bold hand">{props.data.moeinTitle}</NavLink> } });
            if (f.field == 'documentNumber' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.showDocument(props.data.documentId)}>{props.data.documentNumber}</a> } });
            if (f.field == 'description' && f.show) t.push({ flex: 3, field: f.field, headerName: f.caption });
            if (f.field == 'bed' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bed) } });
            if (f.field == 'bes' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bes) } });
            if (f.field == 'remain' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.remain) } });
            if (f.field == 'tashkis' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div className="container">
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h3 className="nk-block-title page-title">گردش حساب {this.state.data.account.title} - <b>{this.state.data.account.fullCode}</b></h3>
                    </div>
                    <div className="nk-block-head-content">
                        <div className="toggle-wrap nk-block-tools-toggle">
                            <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                            <div className="toggle-expand-content" data-content="pageMenu">
                                <ul className="nk-block-tools g-3">
                                    <li>
                                        <a className="btn btn-white btn-outline-light" onClick={e => this.onPrint('گردش حساب ' + this.state.data.account.title)}><span>چاپ</span></a>
                                    </li>
                                    <li>
                                        <a className="btn btn-white btn-outline-light" onClick={e => this.onPdf('گردش حساب ' + this.state.data.account.title)}><span>PDF</span></a>
                                    </li>
                                    <li>
                                        <a className="btn btn-white btn-outline-light" onClick={e => this.onExcel('گردش حساب ' + this.state.data.account.title)}><span>اکسل</span></a>
                                    </li>
                                </ul>
                            </div>
                            <div className="mt-2 flex flex-row gap-4">
                                <input type="checkbox" checked={this.state.groupByMoein} onChange={e => {
                                    this.state.groupByMoein = e.target.checked;
                                    this.refreshData();
                                }} />
                                نمایش تجمیع تراکنش ها بر اساس حساب معین
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {this.renderAgGrid({
                columnDefs: this.getColumns()
            })}
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.getGlobalContainer(),
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.isEmpty(this.state.data.global.annuals) ? this.renderNoAnnual() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),
                <Footer />,
            ];

        return contents;
    }
}